import React from 'react';
import HeroSlider from '../components/home/HeroSlider';
import OurProjects from '../components/home/OurProjects'; // <-- added
import CompanyIntro from '../components/home/CompanyIntro';
import Benefits from '../components/home/Benefits';
import Statistics from '../components/home/Statistics';
import WhyChooseUs from '../components/home/WhyChooseUs';
import CompaniesMarquee from '../components/home/CompaniesMarquee';


const HomePage = () => {
  return (
    <div className="home-page">
      <HeroSlider />
       <Benefits />
      <CompanyIntro />
     
      <Statistics />
     <OurProjects />
      <WhyChooseUs />
       <CompaniesMarquee />
     
    </div>
  );
};

export default HomePage;